import axios from 'axios';

// ACTION TYPES
const name = 'data';
export const actionTypes = {
  LOAD_DATA: `${name}:load_data`,
  LOAD_FUND_DATA: `${name}:load_fund_data`,
  SET_YTW: `${name}:set_ytw`,
  SET_DURATION: `${name}:set_duration`,
  SET_YTW_VS: `${name}:set_ytw_vs`,
  SET_DURATION_VS: `${name}:set_duration_vs`,
  SET_WEIGHTS: `${name}:set_weights`,
  UPDATE_FUND: `${name}:update_fund`,
  FILTER_DATA: `${name}:filter_data`,
  UPDATE_SELECTED: `${name}:update_selected`,
  LOAD_AGG_INDEX: `${name}:load_agg_index`,
};

// ACTIONS
export function loadData() {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/fibarbell/datav2/`,
    };
    return axios(request)
      .then((response) => {

        // Get original data with all tickers needed
        const aggregateData = response.data;

        // Update the 'I00001US' ticker to the bloomberg ticker (LBUSTRUU)
        const updatedAggData = aggregateData.map( fundToCheck => {
          if (fundToCheck.entityID === 'I00001US'){
            fundToCheck.entityID = 'LBUSTRUU';
          }
          return fundToCheck;
        });

        // Load other fund data
        loadFundData(updatedAggData)
          .then((updatedFunds) => {

            updatedFunds.sort( compareFunds );
            const fundsToLoad = updatedFunds.filter( fund => fund.entityID !== 'LBUSTRUU');
            const aggData = updatedFunds.filter( fund => fund.entityID === 'LBUSTRUU')[0];
            
            dispatch({ type: actionTypes.LOAD_AGG_INDEX, value: aggData });
            dispatch({ type: actionTypes.LOAD_DATA, value: fundsToLoad });

            // Go and get standardized performance for the two selected funds
            return getUpdatedFunds(aggregateData, ['AGGY', 'USFR'])
            .then((selectedFunds) => {
              dispatch({ type: actionTypes.UPDATE_SELECTED, leftFund: selectedFunds[0], rightFund: selectedFunds[1] });
              return dispatch(updateWeights(getState().data.weights[1]));
            });
         });
        
      })
      .catch((error) => {
        console.error(error);
      });
  };
}

function formatAsOfDate(date) {
  let asofs = date.split('-');
  return asofs[1] + '/' + asofs[2] + '/' + asofs[0];
}

// Enrich the fund with duration, yield, etc.
function enrichFund(allFunds, fundToEnrich){

  // Find the matching fund aggregate data. Works on entityID as this is returned originally for all funds
  // from loadData() 
  const foundFund = allFunds.filter(fundToCheck => fundToCheck.entityID === fundToEnrich.ticker);

  // Assign it to the fund object
  if (foundFund.length > 0) {

    fundToEnrich.entityID = foundFund[0].entityID;
    fundToEnrich.asOfDate = foundFund[0].dt ? formatAsOfDate(foundFund[0].dt) : foundFund[0].asOfDate;
    fundToEnrich.modifiedDuration = foundFund[0].modifiedDuration;
    fundToEnrich.yieldToWorst = foundFund[0].yieldToWorst;

  }

}

function loadFundData(aggregateData) {

  const tickers = aggregateData.map(fund => {
    return fund.entityID;
  });

  //  Get the fund highlights data
  const fundRequest = {
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}/fundhighlights/data_minimal/`,
    params: {
      tickers: tickers.join(),
    },
  };

  return axios(fundRequest)
    .then((fundResponse) => {

      const fundsToLoad = fundResponse.data;

      for (const fund of fundsToLoad) {
        enrichFund(aggregateData, fund);
      }

      return fundsToLoad;

    })
    .catch((error) => {
      console.error(error);
    });
}

// Get updated fund data (including common period performance)
function getUpdatedFunds(allFunds, tickers) {

  //  Get the fund highlights data
  const fundRequest = {
    method: 'GET',
    url: `${process.env.REACT_APP_API_URL}/fundhighlights/data/`,
    params: {
      tickers: tickers.join(),
    },
  };

  return axios(fundRequest)
    .then((fundResponse) => {

      const updatedFunds = fundResponse.data;
      for (const fund of updatedFunds){
        enrichFund(allFunds, fund);
      }
      return fundResponse.data;

    })
    .catch((error) => {
      console.error(error);
    });


}

export function updateWeights(value) {
  return (dispatch, getState) => {

    const leftFund = getState().data.leftFund;
    const rightFund = getState().data.rightFund;
    const aggData = getState().data.aggData;

    const weights = [100 - value, value];
    const ytw = (((weights[0] * leftFund.yieldToWorst) + (weights[1] * rightFund.yieldToWorst)) / 100).toFixed(2);
    const duration = (((weights[0] * leftFund.modifiedDuration) + (weights[1] * rightFund.modifiedDuration)) / 100).toFixed(2);

    // Calc the yield and duration vs the Agg index
    const ytwVS = (ytw - aggData.yieldToWorst).toFixed(2);
    const durationVS = (duration - aggData.modifiedDuration).toFixed(2);


    dispatch({ type: actionTypes.SET_WEIGHTS, value: weights });
    dispatch({ type: actionTypes.SET_YTW, value: ytw });
    dispatch({ type: actionTypes.SET_DURATION, value: duration });
    dispatch({ type: actionTypes.SET_YTW_VS, value: ytwVS });
    dispatch({ type: actionTypes.SET_DURATION_VS, value: durationVS });
  };
}

// Set the side of the barbell by a given ticker
export function setSelectedFundSide(side, ticker) {
  return (dispatch, getState) => {

    // Get the other ticker
    let tickers;
    if (side === 'left'){
      tickers = [ticker, getState().data.rightFund.ticker];
    } else{
      tickers = [getState().data.leftFund.ticker, ticker];
    }

    // Go and get standardized performance for the two selected funds
    getUpdatedFunds(getState().data.fundData, tickers)
     .then((selectedFunds) => {
       dispatch({ type: actionTypes.UPDATE_SELECTED, leftFund: selectedFunds[0], rightFund: selectedFunds[1] });
       return dispatch(updateWeights(getState().data.weights[1]));
    });

  };
}

function compareFunds(fund1, fund2) {
  if (fund1.type > fund2.type) {
    return -1;
  }
  return 1;
}
